module.exports = __webpack_public_path__ + "img/16.6d52f3b0.png";